import React from 'react';
import BreadCrum from '../breadcrum/BreadCrum';
import SelectTime from './SelectTime';
import PaymentMethod from '../../appointments/PaymentMethod';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import SelectTimeContinue from './SelectTimeContinue';
import { useEffect } from 'react';
import { monthNames } from '../../helpers/constants';
import { useDispatch } from 'react-redux';
import { createAppointment } from '../../redux/appointments/appointmentAction';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { getCustomerDetails } from '../../redux/users/actionCreator';
import { getBusinessStaff } from '../../redux/staff/staffActions';
import { getSingleBusiness, getSingleBusinessByName } from '../../redux/services/servicesActions';
import Loading from '../../components/Loading';

const Appointment = ({ hide }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const { id, businessName } = useParams();
    const { userData } = useSelector((state) => state.user);
    const { singleBusinessDetails, selectedServices, filteredValues, isBusinessGetting } =
        useSelector((state) => state.services);
    const { staff } = useSelector((state) => state.staff);

    const [activeTab, setActiveTab] = useState('time');
    const [selectedSlots, setSelectedSlots] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [stripeToken, setStripeToken] = useState('');
    const [paymentMethodId, setPaymentMethodId] = useState('');
    const [getToken, setGetToken] = useState(false);
    const [cardId, setCardId] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('existing');
    const [notes, setNotes] = useState('');
    const [phone, setPhone] = useState('');
    const [countryCode, setCountryCode] = useState('+44');
    const [currentDay] = useState(new Date());
    const [paymentType, setPaymentType] = useState('card'); // 'card' or 'cash'
    const [selectedStaff, setSelectedStaff] = useState(null);

    const bookAppointment = () => {
        if (paymentType === 'card') {
            setGetToken(true);
        }
    };

    const handleBooking = () => {
        const { date, month, year } = selectedDate;
        const monthNumber = monthNames.indexOf(month) + 1;
        let formattedDate = `${year}-${monthNumber}-${date}`;
        let time = selectedSlots.split('-')[0];
        let serviceId = selectedServices.map((item) => item.id);
        let servicesAddOns = selectedServices.map((item) => ({
            id: item.id,
            addOns: item.selectedAddOns,
        }));
        let business = singleBusinessDetails?.id;
        let phoneNumber = countryCode + '-' + phone;
        let amount = selectedServices.reduce((total, service) => {
            return (
                total +
                Number(service.price) +
                service?.selectedAddOns.reduce((t, adon) => {
                    return t + adon.price;
                }, 0)
            );
        }, 0);

        // Check if 'rebooked' parameter exists in URL
        const searchParams = new URLSearchParams(location.search);
        const isRebooked = searchParams.has('rebooked');


        let payload = {
            date: formattedDate,
            time,
            serviceId,
            business,
            notes,
            phone: phoneNumber,
            amount,
            email: userData?.email,
            servicesAddOns,
            type: paymentType,
            token: paymentType === 'card' ? stripeToken : '',
            cardId: paymentType === 'card' ? cardId : '',
            paymentMethodId: paymentType === 'card' ? paymentMethodId : '',
        };

        // Add staffMemberId only if staff is selected
        if (selectedStaff?.id) {
            payload.staffMemberId = selectedStaff.id;
        }

        // Add triggeredByReminder only if rebooked parameter exists
        if (isRebooked) {
            payload.triggeredByReminder = true;
        }

        dispatch(
            createAppointment(
                payload,
                () => {
                    setPhone('');
                    setCountryCode('+44');
                    history.push('/customer/upcoming-appointments');
                },
                () => {
                    setPaymentMethodId('');
                    setStripeToken('');
                }
            )
        );
    };

    useEffect(() => {
        if (stripeToken) {
            handleBooking();
        }
    }, [stripeToken]);

    // useEffect(() => {
    //   if (filteredValues.date === "weekdays") {
    //     const today = moment();
    //     const weekday = today.isoWeekday();

    //     // If today is a Saturday or Sunday, select the closest Monday
    //     if (weekday === 6 || weekday === 7) {
    //       setSelectedDate({
    //         date: today.startOf("week").add(1, "day").date(),
    //         day: "Mon",
    //         isSelected: true,
    //         month: today.format("MMMM"),
    //         year: today.year(),
    //       });
    //     } else {
    //       setSelectedDate({
    //         date: today.date(),
    //         day: today.format("ddd"),
    //         isSelected: true,
    //         month: today.format("MMMM"),
    //         year: today.year(),
    //       });
    //     }
    //   } else if (filteredValues.date === "weekends") {
    //     const today = moment();
    //     const weekday = today.isoWeekday();

    //     // If today is Saturday or Sunday, select today, otherwise select the next Saturday
    //     if (weekday === 6 || weekday === 7) {
    //       setSelectedDate({
    //         date: today.date(),
    //         day: today.format("ddd"),
    //         isSelected: true,
    //         month: today.format("MMMM"),
    //         year: today.year(),
    //       });
    //     } else {
    //       setSelectedDate({
    //         date: today.endOf("week").day(6).date(),
    //         day: "Sat",
    //         isSelected: true,
    //         month: today.format("MMMM"),
    //         year: today.year(),
    //       });
    //     }
    //   } else if (filteredValues.date === "All Days") {
    //     const today = moment();
    //     setSelectedDate({
    //       date: today.date(),
    //       day: today.format("ddd"),
    //       isSelected: true,
    //       month: today.format("MMMM"),
    //       year: today.year(),
    //     });
    //   } else {
    //     const parsedDate = moment(filteredValues.date, "DD/MM/YYYY");
    //     const formattedDate = {
    //       date: parsedDate.date(),
    //       day: parsedDate.format("ddd"),
    //       isSelected: true,
    //       month: parsedDate.format("MMMM"),
    //       year: parsedDate.year(),
    //     };
    //     setSelectedDate(formattedDate);
    //   }
    //   window.scrollTo(0, 0);
    // }, []);

    useEffect(() => {
        dispatch(getCustomerDetails());
        // Fetch staff members for this business
        if (singleBusinessDetails?.id) {
            dispatch(getBusinessStaff(singleBusinessDetails.id));
        }
    }, [singleBusinessDetails?.id]);

    useEffect(() => {
        return () => {
            setPhone('');
            setCountryCode('+44');
        };
    }, []);

    useEffect(() => {
        if (id) {
            dispatch(getSingleBusiness(id));
        } else if (businessName) {
            dispatch(getSingleBusinessByName(businessName));
        }
    }, [id, businessName]);

    const hasDetails = singleBusinessDetails && (singleBusinessDetails.id || singleBusinessDetails.name) && singleBusinessDetails.is_payment_enabled;

    if (isBusinessGetting) {
        return <Loading />;
    }

    if (!hasDetails) {
        return (
            <div className="container text-center py-5" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <div className="mb-4">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 10C19 13.9765 16.5855 17.3895 13.167 18.706C12.4419 18.9855 11.5581 18.9855 10.833 18.706C7.4145 17.3895 5 13.9765 5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10Z" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M15 15L21 21" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 10H14" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </div>
                <h2 className="fw-bold poly mb-2" style={{ color: '#0f151d', fontSize: '28px' }}>Business Not Found</h2>
                <p className="poppins text-muted mb-4" style={{ maxWidth: '440px', fontSize: '15px', lineHeight: '1.6' }}>
                    We couldn't find the details for this business. It may have been removed, or the link might be incorrect.
                </p>
                <button onClick={() => history.goBack()} className="text-white booking-btn poppins px-5" style={{ textDecoration: 'none' }}>
                    Back
                </button>
            </div>
        );
    }

    return (
        <div className="container mb-5 mt-4">
            {!hide && (
                <BreadCrum
                    items={
                        activeTab === 'time'
                            ? [
                                  { title: 'Home', path: '/home' },
                                  {
                                      title: 'Business Details',
                                      path: `/business-details/${singleBusinessDetails?.id}`,
                                  },
                                  {
                                      title: 'Services',
                                      path: `/business-details/${singleBusinessDetails?.id}/services`,
                                  },
                                  {
                                      title: 'Select Time',
                                      path: `/business-details/${singleBusinessDetails?.id}/services/book-appointment`,
                                  },
                              ]
                            : [
                                  { title: 'Home', path: '/home' },
                                  {
                                      title: 'Business Details',
                                      path: `/business-details/${singleBusinessDetails?.id}`,
                                  },
                                  {
                                      title: 'Services',
                                      path: `/business-details/${singleBusinessDetails?.id}/services`,
                                  },
                                  {
                                      title: 'Select Time',
                                      path: `/business-details/${singleBusinessDetails?.id}/services/book-appointment`,
                                      action: () => setActiveTab('time'),
                                  },
                                  {
                                      title: 'Confirm',
                                      path: '/business-details/123/services/book-appointment',
                                  },
                              ]
                    }
                />
            )}
            <div className="row">
                <div className="col-lg-8 col-md-7">
                    {activeTab === 'time' ? (
                        <SelectTime
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            selectedSlots={selectedSlots}
                            setSelectedSlots={setSelectedSlots}
                        />
                    ) : (
                        <PaymentMethod
                            getToken={getToken}
                            setGetToken={setGetToken}
                            setStripeToken={setStripeToken}
                            notes={notes}
                            setNotes={setNotes}
                            cardId={cardId}
                            setCardId={setCardId}
                            setPaymentMethodId={setPaymentMethodId}
                            paymentType={paymentType}
                            setPaymentType={setPaymentType}
                            businessDetails={singleBusinessDetails}
                            paymentMethod={paymentMethod}
                            setPaymentMethod={setPaymentMethod}
                        />
                    )}
                </div>
                <div className="col-lg-4 col-md-5">
                    <SelectTimeContinue
                        selectedDate={selectedDate}
                        selectedSlots={selectedSlots}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        currentDay={currentDay}
                        bookAppointment={bookAppointment}
                        phone={phone}
                        setPhone={setPhone}
                        countryCode={countryCode}
                        setCountryCode={setCountryCode}
                        handleBooking={handleBooking}
                        cardId={cardId}
                        paymentType={paymentType}
                        paymentMethod={paymentMethod}
                        staff={staff}
                        selectedStaff={selectedStaff}
                        setSelectedStaff={setSelectedStaff}
                    />
                </div>
            </div>
        </div>
    );
};

export default Appointment;
